<template>
    <div>
        <claim-info :claim="claim" :show-back="false" title="Update Claim Status" @save="saveClaimData"></claim-info>
        <initial-reserves-costs :claim="claim"
                                :show-back-btn="false"
                                title="Reserves & Costs"
                                @save="saveReserveChanges"></initial-reserves-costs>
    </div>
</template>

<script>
    import ClaimInfo from "./ClaimInfo";
    import InitialReservesCosts from './InitialReservesCosts';
    import {mapActions, mapGetters} from "vuex";
    import moment from "moment";

    export default {
        name: "reserves-for-claim",
        components: {
            ClaimInfo,
            InitialReservesCosts
        },
        computed: mapGetters('claim', {claim: 'current'}),
        methods: {
            ...mapActions('claim', ['updateClaim', 'setCurrent', 'updateCosts']),
            saveReserveChanges(data) {
                this.isSaving = true;
                this.updateCosts(data).then(() => {
                    this.isSaving = false;
                });
            },
            saveClaimData(claimData) {
                this.updateClaim(claimData).then(data => this.setCurrent({
                    ...this.theClaim,
                    id: data.id,
                    open_date: moment(claimData.open_date, 'DD/MM/YYYY'),
                    active: claimData.active,
                    outcome: claimData.outcome,
                    close_date: moment(claimData.close_date, 'DD/MM/YYYY'),
                }));
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// ReservesForClaim.vue?524ec01e